import { useState } from "react";
import DefaultImage from "../../assets/png/defaultImage.png";

interface Props {
  images: any[];
  home?: boolean;
}

const ProductImages = ({ images, home }: Props) => {
  const [imageStyles, setImageStyles] = useState({
    transformOrigin: "center",
  });

  const handleMouseMove = (e: React.MouseEvent<HTMLImageElement>) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setImageStyles({
      transformOrigin: `${x}% ${y}%`, // move image based on cursor
    });
  };

  const handleMouseLeave = () => {
    setImageStyles({
      transformOrigin: "center", // reset position
    });
  };
  const [selectedImage, setImage] = useState(0);

  // console.log("🚀 ~ ProductImages ~ images:", images[selectedImage]);

  return (
    <div className="flex lg:flex-row flex-col container max-auto">
      <div className="flex flex-col-reverse lg:flex-row lg:justify-between lg:gap-2 gap-2">
        <div className="flex lg:flex-col flex-row lg:h-full h-fit gap-2 justify-center lg:justify-start lg:py-2">
          {images?.length > 0 ? (
            <>
              {images.map((image, index) => {
                return (
                  <div
                    onClick={() => setImage(index)}
                    className={`h-[75px] transition-all object-contain active:scale-75 active:opacity-70 shadow-custom cursor-pointer  w-[75px]  object-center content-center flex justify-center items-center rounded-lg ${
                      selectedImage === index
                        ? " shadow-[#05A30D] border-[#05A30D]"
                        : ""
                    }`}
                  >
                    <img
                      key={index}
                      src={image}
                      alt="product_img"
                      className="rounded-lg h-full"
                    />
                  </div>
                );
              })}
            </>
          ) : (
            <div
              className={`h-[75px] cursor-pointer w-[75px] object-contain rounded-lg border-1`}
            >
              <img src={DefaultImage} alt="product_img" />
            </div>
          )}
        </div>
        <div
          className={`${
            home
              ? `w-[200px] h-[200px]`
              : `lg:w-[450px] h-[330px] w-[330px] lg:h-[450px]`
          } self-center object-cover overflow-hidden`}
        >
          {images[selectedImage] ? (
            <>
              <img
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                style={imageStyles}
                src={images[selectedImage]}
                alt="product_img"
                className="h-full w-full object-contain md:block hidden hover:scale-150"
              />
              <img
                style={imageStyles}
                src={images[selectedImage]}
                alt="product_img"
                className="h-full w-full object-contain md:hidden block"
              />
            </>
          ) : (
            <img
              style={imageStyles}
              src={DefaultImage}
              alt="product_img"
              className="h-full w-full object-contain"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductImages;
